if (!customElements.get('mobile-nav')) {
  customElements.define(
    'mobile-nav',
    class MobileNav extends HTMLElement {
      connectedCallback() {
        this.mainView = this.querySelector('[data-nav-view="main"]');
        this.subView = this.querySelector('[data-nav-view="sub"]');
        this.backButton = this.querySelector('.mobile-nav__back');
        this.details = this.closest('details');
        this.activeHandle = null;

        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onToggle = this.onToggle.bind(this);

        // Capture phase so the back button click never reaches Dawn's
        // MenuDrawer button handler, which would close the whole drawer.
        this.addEventListener('click', this.onClick, true);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('keyup', this.onKeyUp);
        if (this.details) this.details.addEventListener('toggle', this.onToggle);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick, true);
        this.removeEventListener('keydown', this.onKeyDown);
        this.removeEventListener('keyup', this.onKeyUp);
        if (this.details) this.details.removeEventListener('toggle', this.onToggle);
      }

      onKeyDown(event) {
        // Links with role="button" must also activate on Space.
        if (event.code !== 'Space') return;
        const trigger = event.target.closest('a[data-nav-target]');
        if (!trigger) return;
        event.preventDefault();
        this.openSubmenu(trigger.dataset.navTarget);
      }

      onToggle() {
        if (!this.details.open) this.showMain(false);
      }

      onKeyUp(event) {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        if (this.subView.hidden) return;
        // Step back to the main view instead of letting MenuDrawer close the drawer.
        event.stopPropagation();
        this.showMain(true);
      }

      onClick(event) {
        if (this.backButton && event.target.closest('.mobile-nav__back')) {
          event.preventDefault();
          event.stopPropagation();
          this.showMain(true);
          return;
        }

        const trigger = event.target.closest('[data-nav-target]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.openSubmenu(trigger.dataset.navTarget);
      }

      openSubmenu(handle) {
        const panel = this.querySelector(`[data-nav-panel="${CSS.escape(handle)}"]`);
        if (!panel) return;

        this.activeHandle = handle;
        this.mainView.hidden = true;
        this.subView.hidden = false;

        this.querySelectorAll('[data-nav-panel]').forEach((el) => {
          el.hidden = el !== panel;
        });
        this.querySelectorAll('.mobile-nav__rail-item').forEach((item) => {
          if (item.dataset.navTarget === handle) {
            item.setAttribute('aria-current', 'true');
            item.scrollIntoView({ block: 'nearest' });
          } else {
            item.removeAttribute('aria-current');
          }
        });
        this.querySelectorAll('.mobile-nav__item[data-nav-target]').forEach((item) => {
          item.setAttribute('aria-expanded', item.dataset.navTarget === handle ? 'true' : 'false');
        });

        panel.scrollTop = 0;
        this.subView.querySelector('.mobile-nav__panels').scrollTop = 0;
        const heading = panel.querySelector('.mobile-nav__panel-heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }

      showMain(focusTrigger) {
        this.subView.hidden = true;
        this.mainView.hidden = false;
        this.querySelectorAll('.mobile-nav__item[data-nav-target]').forEach((item) => {
          item.setAttribute('aria-expanded', 'false');
        });

        if (focusTrigger && this.activeHandle) {
          const trigger = this.mainView.querySelector(
            `[data-nav-target="${CSS.escape(this.activeHandle)}"]`
          );
          trigger?.focus({ preventScroll: true });
        }
        this.activeHandle = null;
      }
    }
  );
}
